module.exports = __webpack_public_path__ + "assets/img/zh7.7848f724.png";